module.exports = __webpack_public_path__ + "img/four-leafed-clover.7b1e6d8f.svg";